import { MemberList } from 'ui/components/company/patterns/MemberList/MemberList';

/**
 * 売り手メンバー一覧
 */
export const CompanyMemberList: React.FC = () => {
    return <MemberList />;
};
